import type { AppState } from '../../appstate';
import type { HubState } from '../state';
import { getCurrentHubPersona } from '../selectors/currentPersonaSelector';
import {
    createSelector,
    HubPersona,
    isHubPerson,
    isHubPersonaGeneric,
    PersonType,
} from '../../shared';

export { AppState, HubState };

/**
 * Returns the smtp of the Persona currently in focus.
 * If multiple personas are in focus, undefined is returned.
 */
export const getCurrentPersonaSmtp = createSelector<AppState, HubState, HubPersona, string>(
    'getCurrentPersonaSmtp',
    [getCurrentHubPersona],
    currentPersona => {
        if (currentPersona) {
            if (isHubPerson(currentPersona) || isHubPersonaGeneric(currentPersona)) {
                return currentPersona.info.mainEmailAddress;
            }

            if (
                currentPersona.type === PersonType.PublicDistributionList ||
                currentPersona.type === PersonType.Group
            ) {
                return currentPersona.emailAddress;
            }
        }

        return undefined;
    }
);
export {
    Person,
    FavoritePerson,
    PrivateDistributionList,
    DistributionListMember,
} from '../../shared';
